import { call, put, takeLatest } from "redux-saga/effects";
import curry from "lodash/fp/curry";

import { rsf } from "../../../init/firebase";
import chatActionCreators from "../../actions/chat";
import { isLoading, setRooms, syncRooms } from "../../reducers/chat";
import { ChatType } from "../../../enums";
import { modifiedPreparedRooms } from "../../../utils/chat";
import { getChatRoomsQuery } from "../../../queries/chatRooms";
import { roomDocRef } from "../../../utils/refrences.utils";

const finalQuery = curry((isLast, lastDocSnapshot, query) => {
  let newQuery;
  if (isLast && lastDocSnapshot) {
    newQuery = query.startAfter(lastDocSnapshot).limit(20);
  } else {
    newQuery = query.limit(20);
  }
  return newQuery;
});

function* getCompanyRooms(action) {
  const { companyId, userId, role, last } = action.payload;

  let lastDocSnapshot;
  if (last) {
    lastDocSnapshot = yield roomDocRef(last.id).get();
  }

  const finalQueryWithLast = finalQuery(last)(lastDocSnapshot);
  const companyQuery = finalQueryWithLast(getChatRoomsQuery(ChatType.company, companyId, userId, role));

  try {
    yield put(isLoading({ type: ChatType.company, loading: true }));
    const propertySnapshot = yield call(rsf.firestore.getCollection, companyQuery);
    const preparedRooms = yield modifiedPreparedRooms(propertySnapshot.docs);
    yield put(
      last
        ? syncRooms({ rooms: preparedRooms, chatType: ChatType.company })
        : setRooms({ rooms: preparedRooms, chatType: ChatType.company })
    );
    yield put(isLoading({ type: ChatType.company, loading: false }));
  } catch (ex) {
    console.log(ex.message);
    yield put(isLoading({ type: ChatType.company, loading: false }));
  }
}

export function* watchGetCompanyRooms() {
  yield takeLatest(chatActionCreators.getCompanyRooms.toString(), getCompanyRooms);
}
